import { Flex, Text } from '@brokerbay/elements-web';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { buildCssProp } from 'utils';

type EmptySectionProps = {
  dataCy: string;
  Image: ReactNode;
  mainText: string;
  secondaryText: string;
};

const EmptySection: React.FC<EmptySectionProps> = ({
  dataCy,
  Image,
  mainText,
  secondaryText,
}) => (
    <StyledFlex data-cy={dataCy} vertical align="center" justify="center">
      {Image}
      <StyledPrimaryText thickness="bold">{mainText}</StyledPrimaryText>
      <StyledSecondaryText $color="#8C8C8C">
        {secondaryText}
      </StyledSecondaryText>
    </StyledFlex>
  );

const StyledFlex = styled(Flex)`
  margin-top: 48px;
`;

const StyledSecondaryText = styled(Text)<{ $color?: string }>`
  padding: 0 1ch;
  text-align: center;
  ${({ $color }) => buildCssProp('color', $color)}
`;

const StyledPrimaryText = styled(StyledSecondaryText)`
  margin-top: 16px;
`;

export default EmptySection;
